module.exports = {
	"id": "PL",
	"name": "Poland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.019795,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.007918,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.015836,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.015836,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.003959,
			"31": 0.043549,
			"32": 0.003959,
			"33": 0.019795,
			"34": 0.03959,
			"35": 0.027713,
			"36": 0.015836,
			"37": 0.019795,
			"38": 0.027713,
			"39": 0.043549,
			"40": 0.019795,
			"41": 0.011877,
			"42": 0.055426,
			"43": 0.055426,
			"44": 0.031672,
			"45": 0.023754,
			"46": 0.027713,
			"47": 0.051467,
			"48": 0.067303,
			"49": 1.512338,
			"50": 0.071262,
			"51": 0.300884,
			"52": 0.261294,
			"53": 12.839037,
			"54": 3.519551,
			"55": 0.023754,
			"56": 0.007918,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.003959,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.003959,
			"11": 0.003959,
			"12": 0.011877,
			"13": null,
			"14": null,
			"15": 0.007918,
			"16": 0.007918,
			"17": null,
			"18": 0.007918,
			"19": null,
			"20": 0.007918,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.003959,
			"25": null,
			"26": 0.003959,
			"27": null,
			"28": 0.007918,
			"29": 0.007918,
			"30": 0.003959,
			"31": 0.015836,
			"32": 0.003959,
			"33": 0.007918,
			"34": 0.007918,
			"35": 0.011877,
			"36": 0.011877,
			"37": 0.015836,
			"38": 0.071262,
			"39": 0.023754,
			"40": 0.027713,
			"41": 0.031672,
			"42": 0.043549,
			"43": 0.130647,
			"44": 0.047508,
			"45": 0.138565,
			"46": 0.071262,
			"47": 0.613645,
			"48": 0.451326,
			"49": 8.226802,
			"50": 0.043549,
			"51": 0.007918,
			"52": null,
			"3.5": 0.003959,
			"3.6": 0.015836
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.007918,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.003959,
			"19": null,
			"20": 0.003959,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.007918,
			"27": null,
			"28": 0.007918,
			"29": 0.003959,
			"30": 0.011877,
			"31": 0.007918,
			"32": 0.007918,
			"33": 0.007918,
			"34": 0.011877,
			"35": 0.015836,
			"36": 0.201909,
			"37": 0.063344,
			"38": 0.031672,
			"39": 0.035631,
			"40": 1.536092,
			"41": 0.27713,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.003959,
			"12.1": 0.146483
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.007918,
			"6": null,
			"7": null,
			"8": 0.031672,
			"9": 0.035631,
			"10": 0.324638,
			"3.1": null,
			"3.2": null,
			"5.1": 0.015836,
			"6.1": 0.007918,
			"7.1": null,
			"9.1": 0.170237
		},
		"ios_saf": {
			"8": 0,
			"10": 0.619441423813,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0166932296003,
			"8.1-8.4": 0.0308400343464,
			"9.0-9.2": 0.0147126769359,
			"9.3": 0.224462635304
		},
		"android": {
			"3": 0,
			"4": 0.128609299742,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0160761624677,
			"4.1": 0.463912116925,
			"4.2-4.3": 1.15978029231,
			"4.4": 2.65945659109,
			"4.4.3-4.4.4": 2.68242253747
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.0796186703601,
			"9": 0.0517521357341,
			"10": 0.0557330692521,
			"11": 1.25001312465,
			"5.5": null
		},
		"op_mob": {
			"0": 0.101651214925,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00282364485903
		},
		"edge": {
			"12": 0.047508,
			"13": 0.217745,
			"14": 0.542383
		},
		"ie_mob": {
			"10": 0.497914535211,
			"11": 2.02722346479
		},
		"bb": {
			"7": 0.0090615,
			"10": null
		},
		"samsung": {
			"0": 5.231506
		},
		"and_uc": {
			"0": 0.078533
		},
		"op_mini": {
			"0": 1.36952914022
		},
		"and_chr": {
			"0": 46.48436
		},
		"and_ff": {
			"0": 0.030205
		}
	},
	"total": 98.3756535
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PL.json
 ** module id = 623
 ** module chunks = 0
 **/